import { Component } from '@angular/core';
import { Login } from './../../models/login.model';
import * as myGlobal from '../../assets/global';
import { Platform } from 'ionic-angular';

/**
 * Generated class for the BaseLoginComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'base-login',
  templateUrl: 'base-login.html',
})
export class BaseLoginComponent implements Login {
  text: string;

  constructor(public platform: Platform) {}

  signInWithFacebok(): void {
    window.location.href = myGlobal.base + 'auth-server/provider/fb/login';
  }
  signInWithIN(): void {
    // uncomment when ios login is fixed 
    // const fromAndroid = (this.platform.is('cordova') && this.platform.is('android')) ? '?platform=android' : '';
    // window.location.href = myGlobal.base + '/auth-server/provider/in/login' + fromAndroid;

    // delete when ios login is fixed
    const fromMobile = this.platform.is('cordova') ? '?platform=android' : '';
    window.location.href = myGlobal.base + '/auth-server/provider/in/login' + fromMobile;
  }
  signInWithApp(): void {}
  presentPrivacyModal(): void {}
}



// WEBPACK FOOTER //
// ./src/components/base-login/base-login.ts